import {
  createCrossTabBus,
  CUSTOMER_AUTH_CHANNEL,
  CUSTOMER_CONSENT_CHANNEL,
  CUSTOMER_CART_CHANNEL,
  CUSTOMER_FEATURE_FLAGS_CHANNEL,
  type CustomerAuthCrossTabMessage,
  type CustomerConsentCrossTabMessage,
  type CustomerCartCrossTabMessage,
  type CustomerFeatureFlagsCrossTabMessage,
} from 'pi-kiosk-shared/crossTab';

/** Package G G-AC-11 — opaque accessRevision peer-tab invalidation (BC + storage). */
export const CUSTOMER_ACCESS_REVISION_CHANNEL = 'rpapp-customer-access-revision';

export type CustomerAccessRevisionCrossTabMessage = {
  type: 'access-revision-changed';
  tenantCode: string;
  accessRevision: string;
};

export const customerAuthBus = createCrossTabBus<CustomerAuthCrossTabMessage>({
  channelName: CUSTOMER_AUTH_CHANNEL,
});

export const customerConsentBus = createCrossTabBus<CustomerConsentCrossTabMessage>({
  channelName: CUSTOMER_CONSENT_CHANNEL,
});

export const customerCartBus = createCrossTabBus<CustomerCartCrossTabMessage>({
  channelName: CUSTOMER_CART_CHANNEL,
});

export const customerFeatureFlagsBus = createCrossTabBus<CustomerFeatureFlagsCrossTabMessage>({
  channelName: CUSTOMER_FEATURE_FLAGS_CHANNEL,
});

export const customerAccessRevisionBus =
  createCrossTabBus<CustomerAccessRevisionCrossTabMessage>({
    channelName: CUSTOMER_ACCESS_REVISION_CHANNEL,
  });

/**
 * Cross-tab only — initiator already applied local logout/login/refresh effects.
 * notifyLocalSubscribers:false prevents G3 same-tab self-echo (CSP double-end).
 */
export function publishCustomerAuth(message: CustomerAuthCrossTabMessage): void {
  customerAuthBus.publish(message, { notifyLocalSubscribers: false });
}

export function publishCustomerConsentUpdated(
  tenantCode: string,
  options?: { scope?: 'global' | 'tenant' },
): void {
  customerConsentBus.publish(
    {
      type: 'consent-updated',
      tenantCode,
      source: 'customer',
      ...(options?.scope !== undefined ? { scope: options.scope } : {}),
    },
    { notifyLocalSubscribers: false },
  );
}

export function publishCustomerCartReset(
  tenantCode: string,
  kioskId: number,
  source: string,
): void {
  customerCartBus.publish({
    type: 'cart-reset',
    tenantCode,
    kioskId,
    source,
  });
}

export function publishCustomerFeatureFlagsRevision(revision: number): void {
  customerFeatureFlagsBus.publish({
    type: 'flags-revision-changed',
    revision,
  });
}

/**
 * Cross-tab only — initiator already cleared local failure cache.
 * notifyLocalSubscribers:false prevents same-tab self-echo.
 */
export function publishCustomerAccessRevisionChanged(
  tenantCode: string,
  accessRevision: string,
): void {
  customerAccessRevisionBus.publish(
    {
      type: 'access-revision-changed',
      tenantCode,
      accessRevision,
    },
    { notifyLocalSubscribers: false },
  );
}
